import { S as Swiper } from './index-od979Ty0.js';
import './swiper-core-RAYWN467.js';
import './classes-to-selector-M_EnDm_N.js';

class AnnouncementBar extends HTMLElement {
  autoplay = this.dataset.autoplay === 'true';
  autoplayDelay = this.dataset.autoplayDelay;
  modules = [];

  async connectedCallback() {
    await this.loadModules();
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = Swiper(this, {
      modules: this.modules,
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      centeredSlides: true,
      autoplay: {
        enabled: this.autoplay,
        delay: this.autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
    });
  }

  async loadModules() {
    const { Autoplay } = await import('./index-B_ABsL87.js');
    this.modules.push(Autoplay);
  }
}

customElements.define('announcement-bar', AnnouncementBar);
